import type { EvidenceItem } from "@/mocks/cases";

const typeIcon: Record<string, string> = {
  截图: "ri-image-line",
  录音: "ri-mic-line",
  细节: "ri-list-check-2",
  表格: "ri-file-chart-line",
  聊天记录: "ri-chat-3-line",
  声明截图: "ri-file-paper-2-line",
  合同局部: "ri-file-shield-2-line",
  时间线: "ri-timer-line",
  路透照片: "ri-camera-lens-line",
  定位截图: "ri-map-pin-line",
  通告单: "ri-clipboard-line",
  日程表: "ri-calendar-check-line",
  彩排安排: "ri-sound-module-line",
  直播片段: "ri-live-line",
};

export default function EvidenceChain({ items }: { items: EvidenceItem[] }) {
  return (
    <section id="evidence-chain" className="scroll-mt-24">
      <div className="flex items-center gap-3 mb-5">
        <span className="flex w-10 h-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
          <i className="ri-links-line text-lg" />
        </span>
        <div>
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950">证据链明细</h2>
          <p className="text-xs text-foreground-500">共 {items.length} 项材料 · 标注可核对程度</p>
        </div>
      </div>

      <ul className="flex flex-col gap-4">
        {items.map((ev, index) => (
          <li
            key={`${ev.label}-${index}`}
            className="rounded-lg border border-background-200 bg-background-50 p-5"
          >
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-900 text-xs">
                <i className={typeIcon[ev.type] ?? "ri-file-line"} />
                {ev.type}
              </span>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950">{ev.label}</h3>
              <span
                className={`ml-auto inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs whitespace-nowrap ${
                  ev.verified
                    ? "bg-primary-100 text-primary-800"
                    : "bg-accent-100 text-accent-900"
                }`}
              >
                <i className={ev.verified ? "ri-checkbox-circle-line" : "ri-error-warning-line"} />
                {ev.verified ? "可相互印证" : "待补充核对"}
              </span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{ev.detail}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}